import {useState} from 'react';
import { useLocation } from "react-router-dom";
import { AllowedAccess } from 'react-permission-role'
import { ListItem, ListItemButton, ListItemText, Collapse, } from '@mui/material'

export const SidebarItems = ({ title, tagPermissions = [], items = [], icon }) => {

    const location = useLocation();

    const [collapsedItems, setCollapsedItems] = useState({});
    const toggleItem = (key) => {
        setCollapsedItems((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    return (
        <>
            {/* CREA EL TÍTULO DEL MÓDULO */}
            <AllowedAccess permissions={ tagPermissions } >
                <h6 className='pl-3 pt-4'> <i className={icon}></i> { title } </h6>
                <div className='border-bottom border-secondary ml-3 mr-5'></div>
            </AllowedAccess>

            {/* CREA EL LAS OPCIONES DEL MENU PARA PODER ACCEDER A LAS DISTINTAS PANTALLAS */}
            {
                items.map( ( item, key ) => {
                    
                    if(item.visibility){  
                        // Si el Item no tiene subrutas, entonces muestra un enlace directo
                        if ( item.subRoutes.length === 0 ){

                            return(
                                <AllowedAccess permissions={item.permissions} key={key}>
                                    <ListItem disablePadding className='pl-2'>
                                        <ListItemButton to={item.path} selected={location.pathname === item.path}>
                                            <ListItemText primary={item.name} />
                                        </ListItemButton>
                                    </ListItem>
                                </AllowedAccess>
                            )
                        } else {
                            return (
                                <AllowedAccess permissions={item.permissions} key={key}>
                                    <ListItem disablePadding className='pl-2'>
                                        <ListItemButton to={item.path} onClick={() => toggleItem('collapsed'+title+item.name)}>
                                            <ListItemText primary={item.name} />
                                            {!collapsedItems['collapsed'+title+item.name] 
                                                ? (<i className="fa-solid fa-caret-right"></i>)
                                                : (<i className="fa-solid fa-caret-down"></i>
                                            )}
                                        </ListItemButton>
                                    </ListItem>
                                    <Collapse in={collapsedItems['collapsed'+title+item.name]} timeout="auto">
                                        {
                                            item.subRoutes.map((subItem, subIndex) => {
                                                if (subItem.visibility) {       
                                                    return (
                                                        <AllowedAccess permissions={subItem.permissions} key={subIndex}>
                                                            <ListItem disablePadding className='pl-4'>
                                                                <ListItemButton to={subItem.path} selected={location.pathname === subItem.path}>
                                                                    - &nbsp;
                                                                    <ListItemText primary={subItem.name} />
                                                                </ListItemButton>
                                                            </ListItem>
                                                        </AllowedAccess>
                                                    )
                                                }
                                            })
                                        }
                                    </Collapse>
                                </AllowedAccess>
                            )
                        }
                    }

                })
            }
        </>
    )
}
